import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class TicketUserEmailCountViewService {

    constructor(){

        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);
        
        this.TICKETS_USER_EMAIL_COUNT = '/api/tickets-user-email-count';
        this.GET_LIST_BY_FORM = '/list/form/{formId}';
        this.GET_TOP_BY_FORM = '/top/form/{formId}';

        this.GET_LIST_FOR_EMAIL = '/list/email/{email}';
        this.GET_LIST_FOR_USER = '/list/user/{userId}';


    }

    async getListByForm(formId) {
        try {
            let url = window.location.origin + this.TICKETS_USER_EMAIL_COUNT + this.GET_LIST_BY_FORM;
            url = url
                .replace('{formId}', formId)
            const dateRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return dateRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTopByForm(formId) {
        try {
            let url = window.location.origin + this.TICKETS_USER_EMAIL_COUNT + this.GET_TOP_BY_FORM;
            url = url
                .replace('{formId}', formId)
            const dateRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return dateRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByEmail(email) {
        try {
            let url = window.location.origin + this.TICKETS_USER_EMAIL_COUNT + this.GET_LIST_FOR_EMAIL;
            url = url
                .replace('{email}', email)
            const dateRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return dateRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByUser(userId) {
        try {
            let url = window.location.origin + this.TICKETS_USER_EMAIL_COUNT + this.GET_LIST_FOR_USER;
            url = url
                .replace('{userId}', userId)
            const dateRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return dateRet;
        } catch (err) {
            console.log(err);
        }
    }
}

export default TicketUserEmailCountViewService;
